const locatorClient = {
  get pathname() {
    return window.location.pathname;
  },
  get search() {
    return window.location.search;
  },
};

export default locatorClient;
